@use "variables" as *;

.card {
  min-width: 240px;
  height: 100%;
}

.stack {
  align-items: center;
}

.title {
  font-size: $fontSize-m;
  font-weight: normal;
  text-align: center;
}
